<template>
    <Layout />
</template>

<script>
import { mapActions } from 'vuex';

// @ is an alias to /src
import Layout from '@/layouts/Layout/Layout';
import * as params from '@/utils/urlParams';

export default {
    components: {
        Layout,
    },
    methods: {
        ...mapActions({
            setToken: 'userModule/setToken',
            setInPage: 'userModule/setInPage',
        }),
    },
    created() {
        const urlParams = new URLSearchParams(window.location.search);
        const token =
            this.$route.query[params.PARAM_TOKEN] ||
            urlParams.get(params.PARAM_TOKEN);
        if (token) {
            this.setToken(token);
        }
        // inPage
        const inPage =
            this.$route.query[params.PARAM_IN_PAGE] ||
            urlParams.get(params.PARAM_IN_PAGE);

        if (inPage) {
            this.setInPage(inPage);
        }
    },
};
</script>
